import { produce } from 'immer';

const INITIAL_STATE = {
  data: {},
  list: null,
  total: 0,
  loading: false,
};

export default function degree(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@degree/REQUEST': {
        draft.loading = true;
        break;
      }
      case '@degree/SUCCESS': {
        draft.loading = false;
        draft.data = { ...draft.data, ...action.payload.data };
        break;
      }
      case '@degree/FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}
